export default __webpack_public_path__ + "static/media/11.3583b70d.png";